import { HomePageInventoryItem } from '@app/data/clients/inventoryHydrationServiceClient/queries/types';
import { HomepageWork } from '@app/data/clients/monolithClients/explore/types';
import {
  Item as AnalyticsEcommerceItem,
  AnalyticsItemsList,
  AnalyticsItemsListIDNameMap,
  RbGtmClient,
} from '@redbubble/next-analytics/gtm';
import { round } from 'lodash';

export const trackGA4ViewPromotionHomePage = ({
  promotionName,
  creativeSlot,
}: {
  promotionName: string;
  creativeSlot: string;
}) => {
  RbGtmClient.track({
    event: 'view_promotion',
    page_location: window.location.toString(),
    ecommerce: {
      creative_slot: creativeSlot,
      promotion_name: promotionName,
    },
  });
};

export const trackGA4SelectPromotionHomePage = ({
  promotionName,
  creativeSlot,
}: {
  promotionName: string;
  creativeSlot: string;
}) => {
  RbGtmClient.track({
    event: 'select_promotion',
    page_location: window.location.toString(),
    ecommerce: {
      creative_slot: creativeSlot,
      promotion_name: promotionName,
    },
  });
};

export const trackGA4ViewItemListHomePage = ({
  items,
  listID,
  listName,
}: {
  items: AnalyticsEcommerceItem[];
  listID: string;
  listName: string;
}) => {
  RbGtmClient.track({
    event: 'view_item_list',
    page_location: window.location.toString(),
    search_query_id: null,
    ecommerce: {
      item_list_id: listID,
      item_list_name: listName,
      items,
    },
  });
};

export const trackGA4ViewItemListFanArtHomePage = ({
  items,
  topic,
  listID,
  listName,
}: {
  items: AnalyticsEcommerceItem[];
  topic: string;
  listID: string;
  listName: string;
}) => {
  RbGtmClient.track({
    event: 'view_item_list',
    page_location: window.location.toString(),
    topic,
    search_query_id: null,
    ecommerce: {
      item_list_id: listID,
      item_list_name: listName,
      items,
    },
  });
};

const getDiscountAmount = (inventoryItem: HomePageInventoryItem) => {
  const { price } = inventoryItem;
  if (price && price.discount && price.discount.percent > 0) {
    return round(price.amount - price.discount.amount, 2);
  }
  return 0;
};

export const parseHomePageCarouselItemToAnalyticsEcommerceItem = ({
  inventoryItem,
  index,
}: {
  inventoryItem: HomePageInventoryItem;
  index: number;
}): AnalyticsEcommerceItem => {
  return {
    discount: getDiscountAmount(inventoryItem),
    index: Number.isInteger(index) ? index : null,
    work_id: inventoryItem.workId ? inventoryItem.workId.toString() : '',
    product_type_id: inventoryItem.productTypeId,
    blank_item_id: inventoryItem.blankItemId,
    inventory_item_id: inventoryItem.id,
    retargeting_id: inventoryItem.marketingProductTypeId,
    item_id: inventoryItem.id,
    price: inventoryItem.price ? inventoryItem.price.amount : null,
    quantity: 1,
  };
};

export const trackGA4AddToFavoriteEventHomePage = ({
  work,
  index,
}: {
  work: HomepageWork;
  index: number;
}) => {
  RbGtmClient.track({
    event: 'add_to_wishlist',
    search_query_id: '',
    ecommerce: {
      items: [
        {
          discount: 0, // does not exist on work object
          index: Number.isInteger(index) ? index : null,
          work_id: work.id.toString(),
          item_id: work.id.toString(),
          item_list_id: AnalyticsItemsList.RecommendedWorksCarousel,
          item_list_name:
            AnalyticsItemsListIDNameMap.recommended_works_carousel,
          price: null, // does not exist on work object
          quantity: 1,
        },
      ],
      currency: '',
      value: '',
    },
  });
};

export const parseHomePageRecommendedWorksToAnalyticsEcommerceItem = ({
  recommendedWork,
  index,
}: {
  recommendedWork: HomepageWork;
  index: number;
}): AnalyticsEcommerceItem => {
  return {
    discount: 0, // does not exist on work object
    index: Number.isInteger(index) ? index : null,
    work_id: recommendedWork.id.toString(),
    item_id: recommendedWork.id.toString(),
    price: null, // does not exist on work object
    quantity: 1,
  };
};
